import React, { useContext } from 'react';
import { Text, View } from '@/styles/reactnative';
import { useTranslation } from 'react-i18next';

import TimezoneSelect from 'react-timezone-select';
import { getSetting, useSetting } from '@app/hooks/user/mysetting';
import { SETTING_TYPE_SYSTEM } from '@app/constants/SETTING';
import styled from 'styled-components';
import { media } from '@/styles/Qtheme.ts';
import { MobileCalVW, useIsMobile } from '@utils/CalVW.tsx';
import { currencyData } from '@/app/mobile/organisms/ProfileSetting/ProfileSettingBody/AccountSettings/CurrencyContainer/currencyData';
import { getCustomStyles } from '../customStyle';
import { ThemeContext } from '@/theme/ThemeProvider';

const TimezoneSetting = () => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const isMobile = useIsMobile();

  const { data: setting, updateSetting } = useSetting(SETTING_TYPE_SYSTEM);
  const timezone = getSetting(setting, 'TIMEZONE', 'Asia/Seoul');

  const updateTimezone = (e: any) => {
    updateSetting('TIMEZONE', e.value);
  };

  const customStyles = getCustomStyles(theme);

  return (
    <View
      style={{
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '20px 10px',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <Contents
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          marginBottom: isMobile ? 20 : undefined,
        }}
      >
        <Text
          size={20}
          style={{ fontWeight: '500', marginBottom: isMobile ? 10 : undefined }}
        >
          {t('Timezone')}
        </Text>

        <Text
          size={18}
          style={{ fontWeight: '400', color: '#007AFF', lineHeight: 1 }}
        >
          {t('TimezoneDescription')}
        </Text>
      </Contents>

      <View style={{ width: isMobile ? '100%' : '40%' }}>
        <TimezoneSelect
          styles={customStyles}
          value={timezone}
          onChange={updateTimezone}
        />
      </View>
    </View>
  );
};

export default React.memo(TimezoneSetting);

const Contents = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  margin-top: 20px;
  width: 100%;

  @media ${media.mobile} {
    margin-top: ${MobileCalVW(20)};
    gap: ${MobileCalVW(12)};
  }
`;
